const tables = [
  {
    name: "Invoice No",
  },
  {
    name: "Date",
  },
  {
    name: "Due Date",
  },
  {
    name: "Total Amount",
  },
  {
    name: "Paid Amount",
  },
  {
    name: "Outstanding",
  },
  {
    name: "Payment Status",
  },
  {
    name: "Delivery Status",
  },
];

export default tables;